import React from 'react'
import PropTypes from 'prop-types'
import Button from './button'
import { RESTAURANT_DISPLAY_MODE } from './index'

const RestaurantRow = ({ poolSubscriptionName, restaurant, restaurantDisplayAction, addToPool, removeFromPool }) => {
  let restaurantAnchor = <a key={restaurant.id} href={`/restaurants/${restaurant.id}`}>{restaurant.name}</a>
  let displayButton = <td />
  if (restaurantDisplayAction === RESTAURANT_DISPLAY_MODE.EDIT) {
    displayButton = <td><Button id={restaurant.id} mode="remove" addToPool={addToPool} removeFromPool={removeFromPool} /></td>
  } else if (restaurantDisplayAction === RESTAURANT_DISPLAY_MODE.ADD && !restaurant.addedToPool) {
    displayButton = <td><Button id={restaurant.id} mode="add" addToPool={addToPool} removeFromPool={removeFromPool} /></td>
  }

  const partnerSubscriptionsString = (subscriptions) => {
    if (!subscriptions || subscriptions.length === 0) return "-"
    return subscriptions.map(s => `${s.type || '-'}: ${s.name}`).join(", ")
  }

  const getRestaurantSubscriptionName = (subscriptions) => {
    if (subscriptions && subscriptions.length > 0) {
      const rds = subscriptions.find(s => s.type !== null && s.type.toLowerCase() === "rds")
      if (rds)
        return rds.name

      const broker = subscriptions.find(s => s.type !== null && s.type.toLowerCase() === "restaurantbroker")
      if (broker)
        return broker.name

      return subscriptions[0].name
    }
  }

  const restaurantSubscriptionName = getRestaurantSubscriptionName(restaurant.partnerSubscriptions)
  const warning = (restaurantSubscriptionName && restaurantSubscriptionName !== poolSubscriptionName)
    ? <span data-toggle="tooltip" title={`Restaurant subscription: "${restaurantSubscriptionName}" differs from pool subscription: "${poolSubscriptionName}"`}>
      <i className="fa fa-exclamation-triangle" />
    </span>
    : <React.Fragment />

  return (
    <tr key={restaurant.id}>
      <td>{restaurant.id}</td>
      <td name="RestaurantName">{restaurantAnchor}</td>
      <td>{partnerSubscriptionsString(restaurant.partnerSubscriptions)}</td>
      <td>{warning}</td>
      {displayButton}
    </tr>
  )
}

export default RestaurantRow

RestaurantRow.propTypes = {
  poolSubscriptionName: PropTypes.string,
  restaurant: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    addedToPool: PropTypes.bool,
    partnerSubscriptions: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string
    }))
  }).isRequired,
  restaurantDisplayAction: PropTypes.symbol.isRequired,
  addToPool: PropTypes.func,
  removeFromPool: PropTypes.func
}

RestaurantRow.defaultProps = {
  addToPool: () => {},
  removeFromPool: () => {}
}


// WEBPACK FOOTER //
// ./src/containers/pools/details/restaurants/restaurantRow.js